<template>
<div class="wrap">
	<div v-for="contact in contacts" class="card" :key="contact.name">
		<div class="card__name">{{getLocaleContact(contact.name)}}:</div>
		<div class="card__value">{{contact.value}}</div>
		<div class="card__value">
			<confirm-dialog v-bind="propConfirmDialog" @accept="onDelete(contact)">
				<v-icon class="delete-contact" color="red">delete</v-icon>
			</confirm-dialog>
		</div>
	</div>
	<div class="btn-add">
		<v-tooltip top slot="activator">
			<v-btn slot="activator" fab dark color="indigo" @click="onOpen" small>
				<v-icon dark>add</v-icon>
			</v-btn>
			<span>{{$t('common.add')}}</span>
		</v-tooltip>
	</div>
	<v-dialog v-model="dialog"
		max-width="500px"
		persistent
	>
		<v-card>
			<v-card-title>
				<span class="headline">{{$t('workers.add_contact')}}</span>
			</v-card-title>
			<v-card-text>
				<v-container grid-list-md>
					<v-layout>
						<v-flex xs12 sm6 md6 d-flex>
							<v-select
								:items="listContacts"
								:label="$t('common.type_contact')"
								v-model="newContact.name"
								item-value="type"
							/>
						</v-flex>
						<v-flex xs12 sm6 md6>
							<v-text-field :label="$t('common.value')"
								v-model="newContact.value"
							/>
						</v-flex>
					</v-layout>
				</v-container>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn color="red darken-1" flat @click="cancel">{{$t('common.close')}}</v-btn>
				<v-btn color="green darken-1" flat @click="save">{{$t('common.ok')}}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</div>
</template>

<script>
import ConfirmDialog from './ConfirmDialog'
import { TEMPLATE_CONTACT } from '../constants'

export default {
	data: vm => ({
		dialog: false,
		listContacts: vm.contactTypes,
		newContact: { ...TEMPLATE_CONTACT },
		propConfirmDialog: {
			message: vm.$t('workers.confirm_contact'),
			title: vm.$t('workers.deleting_contact'),
			btnProps: {
				dark: true,
				small: true,
				fab: true,
				outline: true,
				style: 'border: none'
			}
		}
	}),
	components: {
		ConfirmDialog
	},
	props: {
		contacts: Array,
		contactTypes: Array
	},
	methods: {
		clearForm() {
			this.newContact = { ...TEMPLATE_CONTACT }
		},
		cancel() {
			this.closeDialog()
			this.clearForm()
		},
		save() {
			this.$emit('add', { ...this.newContact })
			this.closeDialog()
			this.clearForm()
		},
		onDelete(contact) {
			this.$emit('delete', contact)
		},
		closeDialog() {
			this.dialog = false
		},
		onOpen() {
			this.dialog = true
		},
		getLocaleContact(key) {
			const name = this.listContacts.find(({ type }) => type === key)
			return name ? name.text : ''
		}
	}
}
</script>

<style scoped>
.wrap {
	position: relative;
	min-height: 50px;
	width: 100%;
}
.card {
	position: relative;
	display: flex;
	padding: 5px;
	align-items: center;
	font-size: 16px;
	height: 30px;
}
.btn-add {
	position: absolute;
	top: 0;
	right: 0;
}
.card__value {
	margin-left: 10px;
}
.delete-contact {
	cursor: pointer;
	user-select: none;
}
</style>
